import i18n from '@customer/i18n';
import { EmptyCell, GenericValueFormatterFunc } from './genericFormatters';

export const OnOffFormatter: GenericValueFormatterFunc<boolean | null> = ({ value }) => {
  return typeof value === 'boolean' ? i18n.t(value ? 'On' : 'Off') : EmptyCell;
};

export const YesNoFormatter: GenericValueFormatterFunc<boolean | null> = ({ value }) => {
  return typeof value === 'boolean' ? i18n.t(value ? 'Yes' : 'No') : EmptyCell;
};

export const GoodInvalidFormatter: GenericValueFormatterFunc<boolean | null> = ({ value }) => {
  return typeof value === 'boolean' ? i18n.t(value ? 'Good' : 'Invalid') : EmptyCell;
};

export const OkFailFormatter: GenericValueFormatterFunc<boolean | null> = ({ value }) => {
  return typeof value === 'boolean' ? i18n.t(value ? 'OK' : 'Fail') : EmptyCell;
};
